import { combineReducers } from 'redux';
import Immutable from 'seamless-immutable';

import * as actionTypes from './action-types';

function byPrettyId(state = Immutable({}), action) {
  switch (action.type) {
    case actionTypes.FETCH_COMPANY_ADVISOR_CONNECTIONS_FOR_ADMIN_BY_PRETTY_ID.START:
      return state.merge(
        {
          [action.payload.prettyId]: {
            fetchingCompanyAdvisorConnectionsForAdmin: true,
          },
        },
        { deep: true }
      );
    case actionTypes.FETCH_COMPANY_ADVISOR_CONNECTIONS_FOR_ADMIN_BY_PRETTY_ID.SUCCESS:
      return state.merge(
        {
          [action.payload.prettyId]: {
            fetchingCompanyAdvisorConnectionsForAdmin: false,
            lastFetchedCompanyAdvisorConnectionsForAdminAt: new Date().toISOString(),
          },
        },
        { deep: true }
      );
    case actionTypes.FETCH_COMPANY_ADVISOR_CONNECTIONS_FOR_ADMIN_BY_PRETTY_ID.FAILURE:
      return state.merge(
        {
          [action.payload.prettyId]: {
            fetchingCompanyAdvisorConnectionsForAdmin: false,
          },
        },
        { deep: true }
      );
    default:
      return state;
  }
}

function byId(state = Immutable({}), action) {
  switch (action.type) {
    case actionTypes.UPDATE_SOFT_CONNECTION_STATUS.START:
      return state.merge(
        {
          [action.payload.advisorId]: {
            updatingAdminStatus: true,
            updateError: false,
          },
        },
        { deep: true }
      );
    case actionTypes.UPDATE_SOFT_CONNECTION_STATUS.SUCCESS:
      return state.merge(
        {
          [action.payload.advisorId]: {
            updatingAdminStatus: false,
            lastUpdatedAdminStatusAt: new Date().toISOString(),
          },
        },
        { deep: true }
      );
    case actionTypes.UPDATE_SOFT_CONNECTION_STATUS.FAILURE:
      return state.merge(
        {
          [action.payload.advisorId]: {
            updatingAdminStatus: false,
            updateError: action.payload.error,
          },
        },
        { deep: true }
      );
    default:
      return state;
  }
}

export default combineReducers({
  byPrettyId,
  byId,
});



// WEBPACK FOOTER //
// ./src/store/features/admin/companies/advisors/reducer.js